import React from "react";
import { DJANGO_MEMBER_URLS } from "../classicSite.constants";
import LegacyManagedCard from "./LegacyManagedCard";

const BILLING_CARDS = [
  {
    title: "Account overview",
    description:
      "Stripe customer, payment sources, subscription list, and active listing count. Aggregated in Django account_overview view only.",
    djangoUrl: DJANGO_MEMBER_URLS.profile,
    phaseNote: "Phase 5 — billing hybrid or REST API required.",
  },
  {
    title: "Subscriptions",
    description:
      "View and manage Stripe subscriptions. Checkout uses embedded React bundle in Django templates.",
    djangoUrl: DJANGO_MEMBER_URLS.subscriptions,
    phaseNote: "Phase 5 — no Stripe in React silo.",
  },
  {
    title: "Choose a plan",
    description:
      "Member plan selection with session-stored plan IDs and Stripe plan configuration.",
    djangoUrl: DJANGO_MEMBER_URLS.subscriptionChoose,
    phaseNote: "Phase 5.",
  },
  {
    title: "Onboarding plan picker",
    description: "Public plan selection during signup flow.",
    djangoUrl: "/plans/choose/",
    phaseNote: "Phase 5.",
  },
  {
    title: "Payment methods",
    description:
      "Add, update, or remove cards via Stripe. All payment views are Django template + Stripe.js.",
    djangoUrl: "/member/accounts/payments/add/e/",
    phaseNote: "Phase 5 — hybrid ajax possible; not wired in Phase 3.",
  },
  {
    title: "Coupons / fast track",
    description:
      "Coupon validation and fast-track session attach use Django session keys and Stripe.",
    djangoUrl: "/fasttrack/",
    phaseNote: "Phase 5.",
  },
];

export default function BillingBlockedSection() {
  return (
    <section className="cs-billing-section">
      <h2 className="cs-panel__title">Billing & subscriptions</h2>
      <p className="cs-billing-section__intro">
        React cannot safely read or manage billing yet. All surfaces below are
        legacy-managed in Django <code>classic_site</code> + Stripe.
      </p>
      <div className="cs-dashboard-grid">
        {BILLING_CARDS.map((card) => (
          <LegacyManagedCard key={card.title} {...card} />
        ))}
      </div>
    </section>
  );
}
